<script setup>
import { inject, computed } from 'vue'

const props = defineProps({
  colspan: { type: [Number, String], default: null },
})

const injectedColspan = inject('reportTableColspan', computed(() => 1))
const resolvedColspan = computed(() => props.colspan ?? injectedColspan.value)
</script>

<template lang="pug">
tr.bg-canvas-500.text-canvas-100.text-xl
  slot(:colspan="resolvedColspan")
</template>
